import Utility from "../../../shared/utility.js";
import EncryptUtility from "../../utility/js/encrypt-utility.js";
import AddFavourite from "../../utility/js/addFav.js";
import breadcrumbComp from "../../common/breadcrumb-comp";
import commonApiService from "../../common/js/common-api-service.js";
import usbService from "./usb-services.js";
import PrinterDetails from "../../common/printer-details";
export default {
  data() {
    return {
      refresh: true,
      backSlash: true,
      actionList: [],
      mainPage: "",
      subPage: "",
      pageUrl: "",
      favouriteList: [],
      showAdd: false,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      labelsOn: true,
      unitIdentifierValid: false,
      searchUnit: "",
      searchUnitDisable: false,
      testPassComments: "",
      testComments: "",
      failFlow: false,
      passFlow: false,
      showPass: false,
      gradeFlow: false,
      gradeAFlow: false,
      failureCode: "",
      failureCodeList: [],
      gradeReason: "",
      gradeReasonList: [],
      unitSearchResult: [],
      searchDetails: false,
      gradeFormValid: false,
      panel: 0,
      stagingLocation: EncryptUtility.localStorageDecrypt("StagingLocation"),
      lpn: EncryptUtility.localStorageDecrypt("LPNNumber"),
      showLastTransaction: false,
      lastTransaction: [],
      showPrimary: true,
      printerConfigured: false,
      gradeAClick: false,
      gradeBClick: false,
      gradeCClick: false,
      gradeDClick: false,
      failClick: false,
      passClick: false,
      cosGrade: "",
      disableLabelsOn: false,
      required: [(v) => !!v || "Field is required"],
      max50Rule: [(v) => (v || "").length <= 50 || "Max Length of 50 character", (v) => !!v || "Field is required"],
      LPNRule: [
        (v) => (v || "").length <= 39 || "Max Length of 39 characters",
        (v) => !!v || "Field is required",
        (value) => /^[0-9]{1,3}(?:-[0-9]{3})*$/.test(value) || "Enter a correct format: 000-000-000-000",
      ],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.primaryName = EncryptUtility.localStorageDecrypt("primaryName");
    this.primaryLabelSize = EncryptUtility.localStorageDecrypt("primaryLabelSize");
    this.primaryPrinterType = EncryptUtility.localStorageDecrypt("primaryPrinterType");
    if (EncryptUtility.localStorageDecrypt("primaryLabelSize") !== null && EncryptUtility.localStorageDecrypt("primaryLabelSize") !== undefined) {
      this.searchUnitDisable = false;
      this.printerConfigured = false;
    } else {
      this.searchUnitDisable = true;
      this.printerConfigured = true;
      let Alert = {
        type: "error",
        isShow: true,
        message: "Receiving/Inventory Printer is not configured, please configure printer",
      };
      this.$store.commit("ConfigModule/Alert", Alert);
      this.$refs.unitIdentifierForm.resetValidation();
    }
  },
  methods: {
    //Reset Function
    resetFunction() {
      this.searchUnit = "";
      this.searchUnitDisable = false;
      this.disableLabelsOn = false;
      this.testPassComments = "";
      this.testComments = "";
      this.failFlow = false;
      this.passFlow = false;
      this.showPass = false;
      this.gradeFlow = false;
      this.gradeAFlow = false;
      this.failureCode = "";
      this.failureCodeList = [];
      this.gradeReason = "";
      this.gradeReasonList = [];
      this.unitSearchResult = [];
      this.searchDetails = false;
      this.panel = 0;
      this.showLastTransaction = false;
      this.lastTransaction = [];
      this.gradeAClick = false;
      this.gradeBClick = false;
      this.gradeCClick = false;
      this.gradeDClick = false;
      this.failClick = false;
      this.passClick = false;
      this.cosGrade = "";
      this.$refs.unitIdentifierForm.resetValidation();
    },
    //Unit Identifier
    async searchUnitIdentifier() {
      if (this.$refs.unitIdentifierForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        let obj = {
          pass: 1,
          user_id: parseInt(this.userId),
          unit: this.searchUnit,
          proj_key: 0,
          main_key: 0,
          results: 0,
          failc_key: 0,
          cos_grade: "",
          b_reason_key: 0,
          flexstring: "",
          comments: "",
          bin: 0,
          lpn: "",
          lbl_size: "",
          printer_type: "",
          sbu_key: 0,
        };
        this.axios
          .post("wc/cosmetic_inspection", obj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let data = JSON.parse(response.data.body.message);
              this.unitSearchResult = data;
              if (this.unitSearchResult?.Result6 == undefined) {
                this.showPass = true;
              } else {
                this.showPass = false;
              }
              this.searchDetails = true;
              this.searchUnitDisable = true;
              this.getFailureCodes();
              this.getGradeCodes();
              this.showLastTransaction = false; 
              this.lastTransaction = [];
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          });
      }
    },
    //Check for Grade buttons
    hasCode(codeToCheck) {
      return this.unitSearchResult?.Result6?.some((item) => item.code === codeToCheck);
    },
    //Submit Test Results
    submitCosmeticInspection() {
      if (this.$refs.gradeForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        let obj = {
          pass: 7,
          user_id: parseInt(this.userId),
          unit: this.searchUnit,
          proj_key: parseInt(this.unitSearchResult?.Result[0]?.project_id),
          main_key: parseInt(this.unitSearchResult?.Result[0]?.main_key),
          results: this.failClick == true ? 2 : 1,
          failc_key: this.failureCode == "" ? 0 : parseInt(this.failureCode),
          cos_grade: this.cosGrade,
          b_reason_key: this.gradeReason == "" ? 0 : parseInt(this.gradeReason),
          flexstring: "",
          comments: this.testComments,
          bin: this.stagingLocation,
          lpn: this.lpn,
          lbl_size: EncryptUtility.localStorageDecrypt("primaryLabelSize"),
          printer_type: EncryptUtility.localStorageDecrypt("primaryPrinterType"),
          sbu_key: 0,
        };
        this.axios
          .post("wc/cosmetic_inspection", obj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let data = JSON.parse(response.data.body.message);
              EncryptUtility.localStorageEncrypt("LPNNumber", this.lpn);
              this.resetFunction();
              this.showLastTransaction = true;
              if (data[0]?.msg !== null && data[0]?.msg != undefined && data[0]?.msg != "") {
                this.lastTransaction = data[0]?.msg;
              }
              if (data[0]?.label !== null && data[0]?.label != undefined && data[0]?.label != "") {
                if (this.labelsOn) {
                  PrinterDetails.printLabelData(data[0]?.label, EncryptUtility.localStorageDecrypt("primaryName"));
                }
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          });
      }
    },
    // Extra Dropdowns
    async getFailureCodes() {
      let obj = {
        pass: 2,
        user_id: parseInt(this.userId),
        unit: "",
        proj_key: parseInt(this.unitSearchResult?.Result[0]?.project_id),
        main_key: parseInt(this.unitSearchResult?.Result[0]?.main_key),
        results: 0,
        failc_key: 0,
        cos_grade: "",
        b_reason_key: 0,
        flexstring: "",
        comments: "",
        bin: 0,
        lpn: "",
        lbl_size: "",
        printer_type: "",
        sbu_key: 0,
      };
      let showMessage = false;
      let data = await usbService.workcenterCosmeticInspection("post", obj, showMessage);
      if (data.message !== "NA") {
        this.gradeReasonList = data;
      }
    },
    //Get Grade Codes
    async getGradeCodes() {
      let obj = {
        pass: 3,
        user_id: parseInt(this.userId),
        unit: "",
        proj_key: parseInt(this.unitSearchResult?.Result[0]?.project_id),
        main_key: parseInt(this.unitSearchResult?.Result[0]?.main_key),
        results: 0,
        failc_key: 0,
        cos_grade: "",
        b_reason_key: 0,
        flexstring: "",
        comments: "",
        bin: 0,
        lpn: "",
        lbl_size: "",
        printer_type: "",
        sbu_key: 0,
      };
      let showMessage = false;
      let data = await usbService.workcenterCosmeticInspection("post", obj, showMessage);
      if (data.message !== "NA") {
        this.failureCodeList = data;
      }
    },
    //Labels On/Off
    labelsOnChange() {
      if (this.labelsOn) {
        this.primaryName = EncryptUtility.localStorageDecrypt("primaryName");
        this.primaryLabelSize = EncryptUtility.localStorageDecrypt("primaryLabelSize");
        this.primaryPrinterType = EncryptUtility.localStorageDecrypt("primaryPrinterType");
      } else {
        this.primaryName = "";
        this.primaryLabelSize = "";
        this.primaryPrinterType = "";
      }
    },
    //LPN Number Format
    lpnNumFormat(event, num) {
      this.lpn = Utility.formatLPNNumber(event, num);
      EncryptUtility.localStorageEncrypt("LPNNumber", this.lpn);
    },
    //Input at Staging Location
    inputStagingLocation() {
      this.stagingLocation = this.stagingLocation?.toUpperCase();
      EncryptUtility.localStorageEncrypt("StagingLocation", this.stagingLocation);
    },
    //Get LPN Number
    async getLPNNumber() {
      let lpnData = await commonApiService.getNextAvailableLPN("get", this.userId);
      if (lpnData.message !== "NA") {
        this.lpn = lpnData[0]?.lpn;
        EncryptUtility.localStorageEncrypt("LPNNumber", this.lpn);
      }
    },
    //To capture printer details once saved
    printerDetails(labelPrinter) {
      if (!labelPrinter) {
        this.searchUnitDisable = false;
        this.printerConfigured = false;
        this.$refs.unitIdentifierForm.resetValidation();
      } else {
        this.searchUnitDisable = true;
        this.printerConfigured = true;
      }
    },
    //Grade A click
    clickGradeA() {
      this.cosGrade = "";
      this.cosGrade = "A";
      this.gradeAClick = true;
      this.gradeBClick = false;
      this.gradeCClick = false;
      this.gradeDClick = false;
      this.failClick = false;
      this.passClick = false;
      this.gradeFlow = true;
      this.gradeAFlow = true;
      this.failFlow = false;
      this.passFlow = false;
      this.showPass = false;
      this.gradeReason = "";
      this.failureCode = "";
      this.testComments = "";
      this.$refs.gradeForm.resetValidation();
    },
    //Grade B click
    clickGradeB() {
      this.cosGrade = "";
      this.cosGrade = "B";
      this.gradeAClick = false;
      this.gradeBClick = true;
      this.gradeCClick = false;
      this.gradeDClick = false;
      this.failClick = false;
      this.passClick = false;
      this.gradeFlow = true;
      this.gradeAFlow = false;
      this.failFlow = false;
      this.passFlow = false;
      this.showPass = false;
      this.gradeReason = "";
      this.failureCode = "";
      this.testComments = "";
      this.$refs.gradeForm.resetValidation();
    },
    //Grade C click
    clickGradeC() {
      this.cosGrade = "";
      this.cosGrade = "C";
      this.gradeAClick = false;
      this.gradeBClick = false;
      this.gradeCClick = true;
      this.gradeDClick = false;
      this.failClick = false;
      this.passClick = false;
      this.gradeFlow = true;
      this.gradeAFlow = false;
      this.failFlow = false;
      this.passFlow = false;
      this.showPass = false;
      this.gradeReason = "";
      this.failureCode = "";
      this.testComments = "";
      this.$refs.gradeForm.resetValidation();
    },
    //Grade D click
    clickGradeD() {
      this.cosGrade = "";
      this.cosGrade = "D";
      this.gradeAClick = false;
      this.gradeBClick = false;
      this.gradeCClick = false;
      this.gradeDClick = true;
      this.failClick = false;
      this.passClick = false;
      this.gradeFlow = true;
      this.gradeAFlow = false;
      this.failFlow = false;
      this.passFlow = false;
      this.showPass = false;
      this.gradeReason = "";
      this.failureCode = "";
      this.testComments = "";
      this.$refs.gradeForm.resetValidation();
    },
    //Fail click
    clickFail() {
      this.cosGrade = "";
      this.gradeAClick = false;
      this.gradeBClick = false;
      this.gradeCClick = false;
      this.gradeDClick = false;
      this.passClick = false;
      this.failClick = true;
      this.passClick = false;
      this.gradeFlow = false;
      this.gradeAFlow = false;
      this.failFlow = true;
      this.passFlow = false;
      this.gradeReason = "";
      this.failureCode = "";
      this.testComments = "";
      this.$refs.gradeForm.resetValidation();
    },
    //Fail click
    clickPass() {
      this.cosGrade = "";
      this.cosGrade = "A";
      this.gradeAClick = false;
      this.gradeBClick = false;
      this.gradeCClick = false;
      this.gradeDClick = false;
      this.failClick = false;
      this.passClick = true;
      this.gradeFlow = false;
      this.gradeAFlow = false;
      this.failFlow = false;
      this.passFlow = true;
      this.gradeReason = "";
      this.failureCode = "";
      this.testComments = "";
      this.$refs.gradeForm.resetValidation();
    },
    //To add or remove Favourite issue
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
    PrinterDetails,
  },
};
